// extracted by mini-css-extract-plugin
var _1 = "OUdEYa6uNAE2RwQqLGYg";
var _2 = "SboIeKWbTE_mdF3Q7Cow";
var _3 = "f0m9MCERVQPTbF6qfwhb";
var _4 = "e7YwuJIxWzePcMEqLrVo";
var _5 = "SboIeKWbTE_mdF3Q7Cow";
var _6 = "f0m9MCERVQPTbF6qfwhb";
var _7 = "e7YwuJIxWzePcMEqLrVo";
var _8 = "ts_NurTledsjlcVCmc9q";
export { _1 as "education", _2 as "education-description", _3 as "education-institution", _4 as "education-institution-period-of-study", _5 as "educationDescription", _6 as "educationInstitution", _7 as "educationInstitutionPeriodOfStudy", _8 as "title" }
